/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";

import HighchartsVariablePie from "highcharts/modules/variable-pie";

HighchartsVariablePie(Highcharts);

function PieChart({ divisionTypeData }) {
  const chartRef = useRef(null);
  // const divisionContData = [
  //   { name: "YMD", y: 26 },
  //   { name: "MD", y: 32 },
  //   { name: "YWD", y: 25 },
  //   { name: "WD", y: 17 },
  // ];

  let formattedData;
  let total;

  if (divisionTypeData && divisionTypeData.length > 0) {
    total = divisionTypeData.reduce((sum, item) => sum + item.y, 0);
    formattedData = divisionTypeData.map((item) => ({
      name: item.name,
      y: (item.y / total) * 100,
      // z: Math.random()
      z: item.receiptCount,
    }));
  }
  // else {
  //   total = divisionContData.reduce((sum, item) => sum + item.y, 0);
  //   formattedData = divisionContData.map((item) => ({
  //     name: item.name,
  //     y: (item.y / total) * 100,
  //     z: Math.random(),
  //   }));
  // }
  const filteredData = formattedData?.filter((item) => item.y > 0);
  useEffect(() => {
    if (chartRef.current) {
      Highcharts.chart(chartRef.current, {
        chart: {
          type: "pie",
          width: 240,
          height: 300,
        },
        title: {
          text: null,
          align: "left",
          style: {
            color: "#585858",
          },
        },
        // tooltip: {
        //   pointFormat: "{point.name}: <b>{point.percentage:.2f}%</b>",
        // },
        tooltip: {
          formatter() {
            return `${this.point.name}: <b>${this.point.y.toFixed(
              0,
            )}%</b><br>Number of Receipts: <b>${this.point.z.toLocaleString(
              "en-IN",
            )}</b>`;
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              connectorWidth: 0,
              enabled: true,
              style: {
                // textAlign: 'center',
                textOverflow: "ellipsis",
                whiteSpace: "wrap",
                color: "white",
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "center",
              },
              distance: -40,
              // formatter: function() {
              //   if (this.point.percentage > 5) {
              //     return this.point.name;
              //   }
              //   return null;
              // },
              formatter() {
                if (this.point.percentage > 5) {
                  return `${this.point.percentage.toFixed(0)}%<br><b>${
                    this.point.name
                  }</b>`;
                }
                return null;
              },
            },
          },
        },
        series: [
          {
            innerSize: "40%",
            name: "Payment Method",
            colorByPoint: true,
            data: filteredData,
          },
        ],
        colors: ["#265B83", "#F974E4", "#85A626", "#4EB6CD"],
      });
    }
  }, [divisionTypeData]);

  return <div ref={chartRef} />;
}

export default PieChart;
